export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
export const ENTER = 'Enter';
export const SPACE = ' ';
export const BACKSPACE = 'Backspace';
export const DELETE = 'Delete';
export const ORIENTATION = { BOTTOM: 'bottom', TOP: 'top' };
